import React, { useMemo, useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooter,
  IconButtonDatatable,
  MasterButton,
  ModalDeleteConfirm,
  SearchInput,
  TableHeader,
  TableToolbar,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useSearchDatatables } from "App/hooks";
import {
  getAllLayananRuang,
  ModalForm,
  headCells,
  deleteLayananRuangById,
  RESET_STATE_LAYANAN,
} from "./helpers";
import { PencilIcon, TrashIcon } from "App/Assets";
import { defaultDateDisplay } from "App/utils/helpers";

let PageSize = 10;

export default function LayananRuang() {
  const classes = STYLE_DEFAULT_MASTER();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PageSize);

  const [showModal, setShowModal] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);

  const [formData, setFormData] = useState(RESET_STATE_LAYANAN);

  const [run, setRun] = useState(false);
  const { data, length } = useSearchDatatables(rows, q, ["name", "initial"]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    (async () => {
      const res = await getAllLayananRuang();
      if (res) {
        setRows(res);
      }
    })();
  }, [run]);

  useMemo(() => {
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [page, data]);

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          run={() => setRun(!run)}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteLayananRuangById(
              formData.id,
              () => setRun(!run),
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Paper className={classes.paper}>
        <TableToolbar title={"Daftar Layanan Ruang"}>
          <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} />
          <MasterButton
            type={"submit"}
            color='green'
            name='Tambah'
            size='md'
            onClick={() => {
              setFormData(RESET_STATE_LAYANAN);
              setShowModal(!showModal);
            }}
          />
        </TableToolbar>
        <TableContainer className='custom-scrollbar'>
          <Table
            className={classes.table}
            aria-labelledby='tableTitle'
            size={"medium"}
            aria-label='enhanced table'>
            <TableHeader
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={length}
              headCells={headCells}
            />
            <TableBody>
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : "#fff",
                      }}>
                      <TableCell
                        component='th'
                        scope='row'
                        padding='none'
                        align='center'>
                        {index + 1}
                      </TableCell>

                      <TableCell
                        component='th'
                        scope='row'
                        padding='none'
                        align='center'>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}>
                          <IconButtonDatatable
                            onClick={() => {
                              setFormData({
                                id: row?.id,
                                layanan_id: row?.layanan_id,
                                name: row?.name,
                                layanan: row?.layanan,
                                initial: row?.initial,
                                status: row?.status,
                                remark: row?.remark,
                              });

                              setShowModal(true);
                            }}>
                            <PencilIcon />
                          </IconButtonDatatable>

                          <IconButtonDatatable
                            onClick={() => {
                              setFormData({
                                ...formData,
                                id: row?.id,
                              });
                              setShowModalDeleteConfirm(
                                !showModalDeleteConfirm
                              );
                            }}>
                            <TrashIcon />
                          </IconButtonDatatable>
                        </div>
                      </TableCell>

                      <TableCell align='left'>{row?.layanan}</TableCell>

                      <TableCell align='left'>{row?.name}</TableCell>
                      <TableCell align='left'>{row?.initial}</TableCell>
                      <TableCell align='left'>
                        {row?.status ? "Aktif" : "Tidak Aktif"}
                      </TableCell>
                      <TableCell align='left'>{row?.remark}</TableCell>

                      <TableCell align='left'>
                        {defaultDateDisplay(row?.createdAt)}
                      </TableCell>
                      <TableCell align='left'>{row?.createdName}</TableCell>
                      <TableCell align='left'>
                        {defaultDateDisplay(row?.updatedAt)}
                      </TableCell>
                      <TableCell align='left'>{row?.updatedName}</TableCell>
                    </TableRow>
                  );
                })}
              {rows.length === 0 && (
                <TableRow>
                  <TableCell align='center' colSpan={headCells.length}>
                    Tidak ada data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <DatatablesFooter
          page={page}
          length={length}
          rowsPerPage={rowsPerPage}
          selectRows={[10, 20]}
          onPageChange={(page) => setPage(page - 1)}
          onSelectChange={(e) => setRowsPerPage(e.target.value)}
        />
      </Paper>
    </div>
  );
}
